var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "point-shadow", style: _vm.styleInfo }, [
    _c("div", { staticClass: "point-shadow-content" }, [
      _c("div", {
        staticClass: "point-shadow-component",
        attrs: { id: "point-shadow-component" },
      }),
      _c(
        "div",
        { staticClass: "point-shadow-tips", style: _vm.tipsStyleInfo },
        [
          _c(
            "div",
            { staticStyle: { width: "100%", "text-align": "center" } },
            [_vm._v("组件将被移出Tab")]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }